import React, { memo } from 'react';
import { formatDuration } from '../utils/noteHelpers';

const SessionTimer = memo(function SessionTimer({ 
  mode, // 'timed' or 'count'
  timeRemaining = 60, // seconds for timed mode
  currentCard = 0,
  totalCards = 25,
  isPaused = false
}) {
  
  if (mode === 'timed') {
    // Circular timer for timed mode
    const circumference = 2 * Math.PI * 28; // radius = 28
    const progress = (timeRemaining / 60) * circumference;
    const isLow = timeRemaining <= 10;
    
    return (
      <div className="timer-circle" data-testid="session-timer">
        <svg width="64" height="64" viewBox="0 0 64 64">
          {/* Background circle */}
          <circle
            cx="32"
            cy="32"
            r="28"
            fill="none"
            stroke="#EBE9E4"
            strokeWidth="4"
          />
          {/* Progress circle */}
          <circle
            cx="32"
            cy="32"
            r="28"
            fill="none"
            stroke={isLow ? '#CC7A6F' : '#E8C4A8'}
            strokeWidth="4"
            strokeDasharray={circumference}
            strokeDashoffset={circumference - progress}
            strokeLinecap="round"
            className="progress-ring"
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span className={`font-serif text-lg ${isLow ? 'text-coral-500' : 'text-cream-900'}`}>
            {timeRemaining}
          </span>
          <span className="text-xs text-wood-500 font-sans">sec</span>
        </div>
        {isPaused && (
          <div className="absolute inset-0 flex items-center justify-center bg-cream-100/80 rounded-full">
            <span className="text-xs text-wood-700 font-sans font-medium">PAUSED</span>
          </div>
        )}
      </div>
    );
  }
  
  // Card counter for count mode
  const progressPercent = ((currentCard) / totalCards) * 100;
  
  return (
    <div className="flex flex-col items-center gap-2" data-testid="session-counter">
      <div className="flex items-baseline gap-1">
        <span className="font-serif text-2xl text-cream-900">{currentCard}</span>
        <span className="text-sm text-wood-500 font-sans">/ {totalCards}</span>
      </div>
      <div className="w-32 progress-bar-container">
        <div 
          className="progress-bar-fill"
          style={{ width: `${progressPercent}%` }}
        />
      </div>
      {isPaused && (
        <span className="text-xs text-wood-700 font-sans font-medium">PAUSED</span>
      )}
    </div>
  );
});

export default SessionTimer;
